export default __webpack_public_path__ + "static/media/xmas-slide2.0279e87b.jpg";